import { createApi } from "@reduxjs/toolkit/query/react";
import { apiurl } from "@/Config/ApiConfig/ApiUrl";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const organizationdashboardApi = createApi({
  reducerPath: "organizationdashboardApi",
  baseQuery,
  tagTypes: ["Dashboard"],
  endpoints: (builder) => ({

    getCustomers: builder.query({
      query: ({
        page = 1,
        pageSize = 20,
      } = {}) => {
        // API URL
        return `/customers?pageNumber=${page}&pageSize=${pageSize}`;
      },
    
      transformResponse: (response) => {
        const {
          totalCount = 0,
          pageNumber = 1,
          pageSize = 20,
          data = [],
        } = response?.data || {};
      
        const rows = data.map((item) => ({
          ...item,
          userTypes: item.userTypes?.map((u) => u.name).join(", ") || "-",
        }));
      
        return {
          rows,
          totalCount,
          pageNumber,
          pageSize,
        };
      },
      
    }),
    


    // toggleLock: builder.mutation({
    //   query: ({ exporterMasterId, requestId }) => {

    
    //     return {
    //       url: `/export/lock/${exporterMasterId}`,
    //       method: "PUT",
    //       headers: {
    //         "X-Request-Id": requestId || `${Date.now()}`,
    //       },
    //     };
    //   },
    //   invalidatesTags: ["Dashboard"],
    // }),
    
    // deleteJob: builder.mutation({
    //   query: ({ exporterMasterId, requestId, reason }) => {
   
    
    //     return {
    //       url: `/export/${exporterMasterId}`,
    //       method: "DELETE",
    //       headers: {
    //         "X-Request-Id": requestId || `${Date.now()}`,
    //         "Content-Type": "application/json",
    //       },
    //       body: JSON.stringify({ reason }),
    //     };
    //   },
    //   invalidatesTags: ["Dashboard"],
    // }),
    
  }),
});

export const {
  useGetCustomersQuery,
  // useToggleLockMutation,
  // useDeleteJobMutation,
} = organizationdashboardApi;
